import { colors } from '../../config/theme';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  collapse: {
    padding: '22px 0px',
    borderBottom: `1px solid ${colors.lighterGray}`
  },
  close: {
    position: 'relative'
  },
  collapseContent: {
    fontFamily: 'GTAM'
  }
});

export default useStyles;
